<template>
    <div class="position-relative">
        <b-form class="px-2" @submit.prevent="addItemdata">
            <h6 class="compo-heading ps-0 mb-3">{{ $t('Package.servicedetails') }}</h6>
            <b-row>
                <b-col lg="4" md="4" sm="4" cols="12">
                    <div class="field">
                        <label>{{ $t('Package.itemname') }}</label>
                        <!-- <AutoComplete :rules="{ required: false }" :required-icon="true" name="itemId" id="itemId"
                        v-model="isvalForm.itemId" label="" /> -->
                        <AutoCompleteField v-model="isvalForm.itemId" :items="itemList" @keyup="LoadItem()"
                            @item-select="auto_change" name="UserId" :rules="{ required: false }" :required-icon="false"
                            id='UserId' />
                    </div>
                    <!-- {{ itemList }} -->
                </b-col>
                <b-col lg="2" md="2" sm="4" cols="12">
                    <div class="field">
                        <TextInput placeholder="" :label="$t('Package.quantity')" name="quantity" :required-icon="true"
                            v-model="isvalForm.quantity" :rules="{ required: true, numeric: true }"
                            @keyup="qtychange" />
                    </div>
                </b-col>
                <b-col lg="2" md="2" sm="4" cols="12">
                    <div class="field">

                        <CustomDropDown :label="$t('Package.uom')" name="UOM" :required-icon="true"
                            :items="UOMData.UOMOption" v-model="UOMData.UOM" :rules="{ required: true }" />
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <!-- <Footer label="Add" @save="addItemdata()" /> -->
                <b-col class="d-flex flex-row-reverse">
                    <Save @savebtn="addItemdata()" label="Add" />

                </b-col>
            </b-row>
            <!-- {{ serviceList }} -->
            <b-row class="py-5">
                <b-col sm="12">
                    <Tableview :value="serviceList" :paginator="true" class="p-datatable-gridlines" :rows="10"
                        :rowHover="true" filterDisplay="menu" :loading="loading1" responsiveLayout="scroll"
                        :columns="headers" :globalFilterFields="globalFilterFields" :filters="filters"
                        selectionMode="single" dataKey="ID">

                        <template v-slot:action="{ data }">
                            <span>
                                <!-- <EditIcon @click="IsConfirmEdit(data)" class="me-3" />
                  <DeleteIcon @click="IsConfirmDel(data)" /> -->
                                <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                                    @click="toggle($event, data)" />
                                <Menu ref="menu" id="overlay_menu" :model="itemListed" :popup="true" />
                            </span>
                        </template>
                    </Tableview>
                </b-col>
            </b-row>
        </b-form>
    </div>
    <Toast />
</template>

<script lang="ts">
import { RouterLink, RouterView, useRouter } from "vue-router";
import { defineComponent, ref, h, computed, onMounted, watch } from "vue";
import Empty from "../../../../components/Masters/MasterEmpty.vue";
import Tableview from "../../../../components/FormComponents/Table.vue";
import EditConfirmation from "../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../components/FormComponents/DeletedSuccessfully.vue";
import ActivatedSuccessfully from "../../../../components/FormComponents/ActivateSuccessfully.vue";
import InActivatedSuccessfully from "../../../../components/FormComponents/InActivateSuccessfully.vue";
import Mapping from "../../../../components/FormComponents/Mapping.vue";
import MasterEmpty from "../../../../components/Masters/MasterEmpty.vue";
import Loader from "../../../../components/FormComponents/Loader.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import TextInput from "../../../../components/FormComponents/TextInput.vue";
import Footer from "../../../../components/FormComponents/Footer.vue";
import Save from '../../../../components/GeneralButtons/SaveButton.vue'
import ItemMasService from "../../Service/ItemMasService";
import AutoCompleteField from '../../../../components/FormComponents/AutoComplete.vue';
import PackageItemMappingMAPservices from "../../Service/PackageItemMappingService";
import CustomDropDown from "../../../../components/FormComponents/Dropdown.vue";
import { useToast } from "primevue/usetoast";
import { useForm } from "vee-validate";
import { useI18n } from 'vue-i18n';


export default defineComponent({
    components: {
        AutoCompleteField,
        Save,
        Empty,
        Tableview,
        EditConfirmation,
        DeleteConfirmationVue,
        DeletedSuccessfully,
        Mapping,
        MasterEmpty,
        Loader,
        ActivatedSuccessfully,
        InActivatedSuccessfully,
        TextInput,
        Footer,
        CustomDropDown
    },
    props: {
        serviceDetailsList: {

        },
        StoreId: {
            type: Number
        }
    },
    setup(props, { emit }) {
        const toast = useToast();
        const { handleSubmit, errors, resetForm, resetField } = useForm();
        let session: any = localStorage.getItem('UsersData')


        session = JSON.parse(session)
        let OrganizationId = Number(session.OrganizationId);
        onMounted(() => {
            LoadItem()
            LoadUOM()
        })
        watch(
            () => props.serviceDetailsList,
            (newVal) => {
                debugger;
                //AddData.value.push(props.requestdata);
                serviceList.value = props.serviceDetailsList
            })
        const items = ref([]);
        const router = useRouter();
        const loading1 = ref(false)
        //DataTable Fields
        const headers = [
            // {
            //     header: "S.No",
            //     field: "RowNumber",
            //     class: 'filterdisplaynone'
            // },

            {
                header: "ITEM NAME",
                field: "ItemName",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                sortable: false,

                bodyclass: 'boldclass',
            },
            {
                header: 'QUANTITY ',
                field: 'Quantity',
                filterTemplate: 'MultiSelect',
                ShowMactchMode: false,
                sortable: false,

                class: 'width150'
            },
            {
                header: 'UOM',
                field: 'UOM',
                filterTemplate: 'MultiSelect',
                ShowMactchMode: false,
                sortable: false,

                class: 'width150'
            },
            {
                header: "",
                field: "action",
                slot: "action",
                frozencolumn: true,
                sortable: false,
                class: "filterdisplaynone last-column-position",
                fieldDisplay: "false",
            },
            // {
            //     header: "Status",
            //     field: "ActiveStatus",
            //     filterTemplate: "MultiSelect",
            //     ShowMactchMode: false,
            //     bodyclass: "bluecolor",
            //     slot: "Status",
            //     fieldDisplay: "false",
            //     sortable: false,
            // },
        ];
        let isvalForm = ref({
            itemId: ref(),
            itemName: ref(),

            quantity: ref('1'),
            UOM: '',

            UOMId: 0

        })
        let UOMData = ref({
            UOMOption: [],
            UOM: ref()
        })
        let serviceList: any = ref([])
        let serviceDeleteList: any = ref([])
        let itemList = ref([])
        let Entitydata = ref();
        Entitydata.value = localStorage.getItem("EntityData");
        Entitydata.value = JSON.parse(Entitydata.value);
        let count = 0;
        function auto_change(e) {
            // alert(JSON.stringify(e.value))
            debugger;
            isvalForm.value.itemName = e.value.label
            isvalForm.value.UOM = e.value.UOM
            isvalForm.value.UOMId = e.value.UnitId
            UOMData.value.UOM = e.value.UnitId
            // createrequestForm.value.ConsumptionType = (type.value.typeCheck[0] == true) ? 2 : 1
            // createrequestForm.value.UserId = (createrequestForm.value.ConsumptionType == 1) ? Number(selectOptions.value.UserId['value']) : 0;
            // createrequestForm.value.PatientId = (createrequestForm.value.ConsumptionType == 2) ? Number(selectOptions.value.UserId['value']) : 0;
            // createrequestForm.value.VisitId = (createrequestForm.value.ConsumptionType == 2) ? Number(selectOptions.value.UserId['visit_reportid']) : 0;
        }

        const addItemdata = handleSubmit(async (values) => {
            debugger;
            count = count + 1;
            if (isvalForm.value.itemId && isvalForm.value.itemName) {
                let count = serviceList.value.filter((item) => item.ItemId == isvalForm.value.itemId.value).length;
                if (count > 0) {
                    toast.add({
                        severity: "warn",
                        summary: "Item Already Exists",
                        detail: "",
                        life: 3000,
                    });
                }
                else {
                    serviceList.value.push({
                        "RowNumber": count,
                        "Id": 0,
                        // "packageId": 0,
                        "ItemId": isvalForm.value.itemId.value,
                        "ItemName": isvalForm.value.itemName,

                        "Quantity": isvalForm.value.quantity,
                        "CreatedBy": 0,
                        "CreatedOn": "2023-11-29T05:49:44.328Z",
                        "ModifiedBy": 0,
                        "ModifiedAt": "2023-11-29T05:49:44.328Z",
                        "IsActive": true,
                        "IsDeleted": true,
                        "EntityId": Number(Entitydata.value.EntityId),
                        "UOM": isvalForm.value.UOM,
                        "UOMId": isvalForm.value.UOMId
                    })
                }
            }
            else {
                toast.add({
                    severity: "warn",
                    summary: "Select the Item",
                    detail: "",
                    life: 3000,
                });
            }
            isvalForm.value.itemId = ''
            isvalForm.value.itemName = ''
            isvalForm.value.UOM = ''
            isvalForm.value.UOMId = 0;
            UOMData.value.UOM = ref()
            isvalForm.value.quantity = '1'

            emit('serviceList', serviceList.value)

        })
        const filters = {
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            Code: { value: null, matchMode: FilterMatchMode.IN, options: items },
            TemplateInfo: { value: null, matchMode: FilterMatchMode.IN, options: items },
        };

        const filteredColumns = computed(() => {
            return headers.filter((col) => col.field !== "id");
        });
        const globalFilterFields = ref(headers.map((col) => col.field));
        async function LoadItem() {
            debugger;
            try {
                if (props.StoreId) {
                    let result = await ItemMasService.GetItemByStoresId(props.StoreId, props.StoreId, isvalForm.value.itemId, 0, 0, 0, 0, 0);
                    console.log(result)
                    if (result["ErrorInfo"]["ErrorCode"] == null) {
                        itemList.value = result["result"].map((item) => {
                            item.label = item.Name,
                                item.value = item.Id
                            return item
                        })
                    }
                }

            }
            catch (error) {

            }

        }
        //Load Unit of Measurement-Added by Tharuni
        async function LoadUOM() {
            try {
                debugger;
                let result = await ItemMasService.OrderingDispensingUnit();
                console.log(result)
                if (result["ErrorInfo"]["ErrorCode"] == null) {
                    UOMData.value.UOMOption = result["result"].filter((i1) => i1.HospitalId == OrganizationId).map((item) => {
                        item.name = item.Name,
                            item.value = item.Id
                        return item;
                    })
                }

            }
            catch (error) {

            }
        }

        let ObjData = ref();

        const menu = ref();
        let InActivevisible = ref(false);
        let Activevisible = ref(false);
        let Editvisible = ref(false);

        const toggle = (event, data) => {
            debugger;
            menu.value.toggle(event);
            // alert(JSON.stringify(data))

            ObjData.value = data;

        };

        const itemListed = ref([
            {
                items: [
                    // {
                    //     label: "Edit",
                    //     icon: "editicon pi pi-pencil",
                    //     visible: Editvisible,
                    //     command: async () => {
                    //         // IsConfirmEdit(ObjData);
                    //     },
                    // },
                    {
                        label: "Delete",
                        icon: "deleteicon pi pi-trash",
                        visible: true,
                        command: async () => {

                            // alert(JSON.stringify(ObjData.value.itemId))
                            serviceList.value = serviceList.value.filter((item) => item.ItemId != ObjData.value.ItemId)

                            if (ObjData.value.Id != 0) {
                                serviceDeleteList.value.push({
                                    'Id': ObjData.value.Id
                                })
                            }
                            // alert(serviceDeleteList.value.length)

                            emit('serviceDeleteList', serviceDeleteList.value)

                            // IsConfirmDel(ObjData, 0);
                        },
                    },


                ],
            },
        ]);
        //  async function IsDelete(data) {
        //     debugger;
        //     const DelID = data.value.Id;
        //     try {
        //         let data_response: any = "";
        //                            data_response = await PackageItemMappingMAPservices.Delete(DelID);

        //         // const data_response = await service.Delete(DelID, data.ActiveStatus);
        //         console.log(data_response);
        //         let message = data_response["ErrorInfo"].ErrorCode;

        //         if (message == null) {
        //             // if (data.ActiveStatus == 1) {
        //             //     loading.value = false;
        //             //     popup.value.activatepop = true;
        //             // } else if (data.ActiveStatus == 2) {
        //             //     loading.value = false;
        //             //     popup.value.inactivepop = true;
        //             // } else {
        //             //     loading.value = false;
        //             //     deletepop.value = true;
        //             // }
        //             // deletepop.value = true;
        //             // Deletemodel.value = false;
        //             // rowFocus.value = false;
        //             // IsShow();
        //         }
        //     } catch (error) {
        //         // loading.value = false;
        //         alert(error);
        //     }
        // }
        //Quantity change
        function qtychange() {

            isvalForm.value.quantity = (isvalForm.value.quantity == '0') ? '1' : isvalForm.value.quantity
        }
        return {
            qtychange,
            itemListed,
            toggle,
            menu,
            auto_change,
            LoadItem,
            isvalForm,
            serviceList,
            itemList,
            addItemdata,
            items,
            loading1,
            filteredColumns,
            globalFilterFields,
            headers,
            filters,
            UOMData
        }
    }
})
</script>